module.exports = __webpack_public_path__ + "img/Yemen.5304829d.png";